import { useContext } from "react";

import { GetAccessTokenContext } from "../context";
import { NotWrappedError } from "../functions";

const useGetAccessToken = () => {
  const context = useContext(GetAccessTokenContext);
  if (context === null) throw new NotWrappedError();
  return context!;
};

export default useGetAccessToken;
